// extracted by mini-css-extract-plugin
export var dataCell = "_r3-2";
export var dataRow = "_r3-0";
export var headerRow = "_r3-1";